export function stringToColor (string: string) {
  let hash = 0
  let i

  /* eslint-disable no-bitwise */
  for (i = 0; i < string.length; i += 1) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash)
  }

  let color = '#'

  for (i = 0; i < 3; i += 1) {
    const value = (hash >> (i * 8)) & 0xff
    color += `00${value.toString(16)}`.substr(-2)
  }
  /* eslint-enable no-bitwise */

  return color
}

export function stringAvatar (name: string, size?: number, border?: string) {
  return {
    sx: {
      bgcolor: stringToColor(name),
      width: size || 40,
      height: size || 40,
      border: border || ''
    },
    children: `${name.substr(0, 2)}`
  }
}
